<h2>{{ 'forms.dashboard.title' | translate }}</h2>

<div class="form-group col-sm-12" style="padding-right: 0px">
  <div class="pull-right">
    <a [routerLink]="['/forms/formbuilder']" class="atlas-btn atlas-btn-default">
      <i class="pi pi-plus"></i>
      {{ 'common.new' | translate | titlecase }}
    </a>
  </div>
</div>
<div style="clear: both"></div>

<p-table [showGridlines]="true"
  #formsGrid
  [lazy]="true"
  [rows]="20"
  styleClass="wl-responsive-prime-datatable"
  [value]="formsResult.Result"
  [paginator]="true"
  (onLazyLoad)="lazyLoadForms($event)"
  [totalRecords]="formsResult.TotalCount"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'forms.dashboard.form-title' | translate | titlecase }}</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-form>
    <tr>
      <td>
        <div style="overflow: hidden">
          <a (click)="editForm(form)">{{ form.Title }} ({{ form.Id }})</a>
        </div>
      </td>
      <td>
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-sm btn-primary"
          icon="pi pi-pencil"
          [disabled]="isSearching || isBusy"
          (click)="editForm(form)"
          [pTooltip]="'common.edit' | translate | titlecase"
          tooltipPosition="top"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2" class="text-center">
        {{ 'forms.no-forms' | translate | titlecase }}
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
